
import {
  FuncaoRPA,
  Usuario
} from '../index';


export class AgendamentoRPAParametro {
  "AgendamentoRPAId";
  "Parametro";
  "Valor";
  "ValorVariavel";
  "DataCadastro";
  "UsuarioCadastro";
  "DataAlteracao";
  "UsuarioAlteracao";
  "id";
  AgendamentoRPA;
  UsuarioCadastroRel;
  UsuarioAlteracaoRel;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AgendamentoRPAParametro`.
   */
  static getModelName() {
    return "AgendamentoRPAParametro";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AgendamentoRPAParametro for dynamic purposes.
  **/
  static factory(data) {
    return new AgendamentoRPAParametro(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'AgendamentoRPAParametro',
      plural: 'AgendamentoRPAParametros',
      path: 'AgendamentoRPAParametros',
      properties: {
        "AgendamentoRPAId": {
          name: 'AgendamentoRPAId',
          type: 'number'
        },
        "Parametro": {
          name: 'Parametro',
          type: 'string'
        },
        "Valor": {
          name: 'Valor',
          type: 'string'
        },
        "ValorVariavel": {
          name: 'ValorVariavel',
          type: 'string'
        },
        "DataCadastro": {
          name: 'DataCadastro',
          type: 'Date'
        },
        "UsuarioCadastro": {
          name: 'UsuarioCadastro',
          type: 'number'
        },
        "DataAlteracao": {
          name: 'DataAlteracao',
          type: 'Date'
        },
        "UsuarioAlteracao": {
          name: 'UsuarioAlteracao',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        AgendamentoRPA: {
          name: 'AgendamentoRPA',
          type: 'FuncaoRPA',
          model: 'FuncaoRPA'
        },
        UsuarioCadastroRel: {
          name: 'UsuarioCadastroRel',
          type: 'Usuario',
          model: 'Usuario'
        },
        UsuarioAlteracaoRel: {
          name: 'UsuarioAlteracaoRel',
          type: 'Usuario',
          model: 'Usuario'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/AgendamentoRPAParametro.js